import type { TUniversity } from '../../types'
import { FC, useMemo } from 'react'
import UniversityItem from './components/university-item'
import { cn } from '@src/design-system/helpers'

const AddressInformation: FC<{ university: TUniversity, modal?: boolean }> = ({ university, modal = true }) => {

    const addressInformation = useMemo(() => {
        const base = [
            {
                label: 'Address 1',
                value: university?.address_line_1,
            },
            {
                label: 'Address 2',
                value: university?.address_line_2,
            },
            {
                label: 'City',
                value: university?.city,
            },
            {
                label: 'ZIP/Postal Code',
                value: university?.postal_code,
            },
            {
                label: 'State/Province',
                value: university?.state,
            },
            {
                label: 'Country',
                value: university?.country?.name,
            },
        ];

        if (modal) {
            return base;
        }

        // Non-modal layout order: Address 1, City, ZIP, Address 2, State, Country
        return [
            base[0], // Address 1
            base[2], // City
            base[3], // ZIP/Postal Code
            base[1], // Address 2
            base[4], // State/Province
            base[5], // Country
        ];
    }, [university, modal])

    return (
        <div className={cn('space-y-4 p-4 m-4 mt-0 bg-white rounded-xl', !modal && 'm-0 p-0')}>
            <p className='font-semibold text-gray-800'>Address Information</p>
            <div className={cn('grid gap-3', modal ? 'grid-cols-1' : 'sm:grid-cols-2 lg:grid-cols-3')}>
                {addressInformation.map((item) => (
                    <UniversityItem key={item.label} label={item.label} value={item.value ?? '—'} />
                ))}
            </div>
        </div>
    )
}

export default AddressInformation